import { connect } from "react-redux";

import { Creators } from "../../../../services/redux/vignets/actions";
import Done from "./components";

const mapStateToProps = (state) => {
  const { summaryLink, isGettingSummaryLink, summaryLinkError } = state.vignets;
  return {
    summaryLink,
    isGettingSummaryLink,
    summaryLinkError,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSummaryLink: () => {
      dispatch(Creators.newVignetteSummary());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Done);
